import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ReportModel } from '../classes/ReportModel';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { GroupModel } from "../classes/GroupModel";
import { Adal4Service } from "adal-angular4";
import { UserModel } from "../classes/UserModel";
import { UserViewModel } from "../classes/UserViewModel";
import { TokenService } from "./token.service";
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UserService {

  private headers;
  options;
  token: any;
  
  constructor(private AdalService: Adal4Service, private _httpService: Http, private tokenService: TokenService) { 
    
    this.token = this.AdalService.userInfo.token;    
    this.headers = new Headers({'content-Type': 'application/json'});
    this.headers.append('authorization',`bearer ${this.token}`)    

  }

  exportExcelUsers(users: UserModel[]) : Promise<string>{
    let url ="/exportUsers";
    // if (this.tokenService.handleTokenExpiration()){
    //   return null;
    // }       
    return this._httpService
    .post(url, JSON.stringify(users), { headers: this.headers })
    .toPromise()
    .then(url => url.text())
    .catch(this.handleError);
}

  getUsers(): Promise<UserModel[]> {
    let url = "/api/getallusers"; 
    this.tokenService.handleTokenExpiration();  
    return this._httpService.get(url, { headers: this.headers })
      .toPromise()
      .then(users => users.json())
      .catch(this.handleError);
  }

  

  addUser(userVm: UserViewModel): Promise<UserModel> {
    let url = "/api/registeruser"; 
    this.tokenService.handleTokenExpiration();  
    return this._httpService
      .post(url, JSON.stringify(userVm), { headers: this.headers })
      .toPromise()
      .then(user => user.json() as UserModel)
      .catch(this.handleError);
      
  }


  updateUser(idUser: number, userVm: UserViewModel): Promise<UserModel> {
    let url = `/api/Users/${idUser}`;
    this.tokenService.handleTokenExpiration();  
    return this._httpService
      .put(url, JSON.stringify(userVm), { headers: this.headers })
      .toPromise()
      .then(res => res.json() as UserModel)
      .catch(this.handleError);

  }

  deleteUser(idUser: number) {
    let url = `/api/Users/${idUser}`;
    this.tokenService.handleTokenExpiration();  
    return this._httpService
      .delete(url, { headers: this.headers })
      .toPromise()
      .then(res => res)
      .catch(this.handleError);
  }

  auditLogin(email: string){
    let url = `api/login?email=${email}`;
    console.log("dentro de método de login");
    this._httpService.get(url).subscribe(() => {
      console.log("auditoria de login bem sucedida");
    },error => {
      console.log("Erro na auditoria do login: ", error);
    })
  }

  // auditLogin(email: string){
  //   let url = `api/login?email=${email}`;
  //   console.log("dentro de método de login");
  //   this._httpService.get(url).subscribe(res => {
  //     console.log("auditoria de login bem sucedida");
  //     console.log(res);
  //   },error => {
  //     console.log("Arro na auditoria do login: ", error);
  //   })
  // }

   private handleError(error: any): Promise<any> {
    console.error('DEU ERRO!', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/services/user.service.ts